import { PayloadAction } from '@reduxjs/toolkit';
import { InitialStateType } from 'src/redux/job-details/types';
import { defaultWebHookDetails } from 'src/redux/job-details/slice';

const reducers = {
  updateJobDetailsData: (
    state: InitialStateType,
    action: PayloadAction<{
      workOrderData: InitialStateType['data']
    }>,
  ) => {
    const { workOrderData } = action.payload;
    if (workOrderData) {
      state.data = {
        ...state.data,
        ...workOrderData,
      };
    }
  },
  clearState: (state: InitialStateType) => {
    state.data = {
      work_order_id: '',
      service_category: '',
      child_job_exist: false,
      state: {
        label: '',
        value: '',
      },
      allowed_states: [],
      address: '',
      webhook_details: {
        enabled: false,
        url: '',
      },
    };
    state.source = {};
    state.webHookDetails = defaultWebHookDetails;
  },
};

export default reducers;
